export default __webpack_public_path__ + "static/media/gwn04.02fc2ee2.webp";